<template>
  <div class="service-wrap pt-20 pb-20">
    <div class="container">
      <!-- En-tête -->
      <div class="row mb-5">
        <div class="col-12 text-center">
          <!-- <h2 class="section-title">Les Mouvements</h2> -->
          <p class="section-subtitle">Les mouvements sont des associations d’engagement créées par les apprenants de l’Ecole (en cours ou en fin de cours). Leur champ d’action est beaucoup plus la cité. Avec les acquis de l’Ecole, ils veulent changer quelque chose dans la cité.
Ces mouvements sont ouverts à tout(e) apprenant(e) désireux(se) d’apporter sa contribution au changement de la société par l’Église. Ces mouvements sont actuellement au nombre de trois : Amis de Mgr Isidore de Souza ; Amis des Séminaires ; La Petite Voie de Sainte Thérèse de l’Enfant-Jésus.
</p>
        </div>
      </div>

      <!-- Grille des formations -->
      <div class="row">
        <div 
          class="col-xl-3 col-lg-4 col-md-6 mb-4" 
        >
          <div class="formation-card">
            <div class="formation-icon-wrapper">
              <i class="flaticon-education formation-icon"></i>
            </div>
            <div class="formation-content">
              <h5 class="formation-title">Amis de Mgr Isidore de Souza</h5>
              <div class="formation-niveau">
                <i class="flaticon-level"></i>
                <span>C’est un mouvement d’engagement sociopolitique à partir des valeurs de la foi chrétienne. Sa vision consiste à former des leaders qui s’inspirent des approches d’action de Mgr Isidore de SOUZA pour une gestion apaisée de la vie démocratique, une cohésion sociale et une paix durable.
Il veut participer au dialogue entre les peuples et à la promotion de la Démocratie et de la Paix en contribuant au renforcement des capacités des jeunes, des femmes, des acteurs des médias et des institutions.

</span>
              </div>
            </div>
          </div>
        </div>
        <div 
          class="col-xl-3 col-lg-4 col-md-6 mb-4" 
        >
          <div class="formation-card">
            <div class="formation-icon-wrapper">
              <i class="flaticon-education formation-icon"></i>
            </div>
            <div class="formation-content">
              <h5 class="formation-title">Amis des Séminaires</h5>
              <div class="formation-niveau">
                <i class="flaticon-level"></i>
                <span>Sa vision est de contribuer (par un soutien spirituel, moral et financier) à l’amélioration des conditions de formation des futurs prêtres et d’œuvrer pour l’avènement de la prise en charge complète et autonome de cette formation par l’Église du Bénin.
En suscitant beaucoup de bonnes volontés acquises à cette noble cause, ils ont pour ambition d’imiter les modèles de la Bienheureuse Pauline JARICOT et de Mme DOMPAGO (béninoise ayant vécu à Ouidah, elle a passé toute sa vie à aider le grand séminaire St Gall, en priant et se donnant corps et âme pour collecter tout ce qui peut servir à la bonne marche de la formation des futurs prêtres).
</span>
              </div>
            </div>
          </div>
        </div>
        <div 
          class="col-xl-3 col-lg-4 col-md-6 mb-4" 
        >
          <div class="formation-card">
            <div class="formation-icon-wrapper">
              <i class="flaticon-education formation-icon"></i>
            </div>
            <div class="formation-content">
              <h5 class="formation-title">La Petite Voie de Sainte Thérèse de l'enfant Jésus</h5>
              <div class="formation-niveau">
                <i class="flaticon-level"></i>
                <span>En suivant l’exemple de Sainte Thérèse de Lisieux, la Petite Voie est un mouvement qui a pour vision d’imprimer une nouvelle civilisation de l’Amour au monde entier en contribuant à inverser l’individualisme et le manque d’amour observés dans le monde.
Être plus humain en aimant davantage le prochain comme soi-même et comme Dieu nous aime puis offrir des opportunités qui induisent le développement intégral.
Créer un réseau mondial de chrétiens vecteurs de paix et d’amour ; une Cité de Paix, d’Amour et de joie ; une communauté où chaque individu pourra mettre ses compétences à la disposition des autres.
Les actions de la Petite Voie sont portées par la prière individuelle et la pratique de la Lectio Divina.
</span>
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script lang="ts">

</script>

<style scoped>
/* -------- SECTION -------- */
.service-wrap {
  background: #f4f6f9;
  padding: 70px 0;
}

.section-title {
  font-size: 2.4rem;
  font-weight: 800;
  color: #0b1b3f;
  margin-bottom: 15px;
  letter-spacing: -0.5px;
}

.section-subtitle {
  font-size: 1.05rem;
  color: #5c6168;
  max-width: 780px;
  margin: 0 auto 45px;
  line-height: 1.6;
}

/* -------- GRID -------- */
.row {
  display: flex;
  flex-wrap: wrap;
}

.col-xl-3, .col-lg-4, .col-md-6 {
  display: flex;
}

/* -------- GLASS CARD DESIGN -------- */
.formation-card {
  background: rgba(255, 255, 255, 0.35);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-radius: 22px;
  border: 1px solid rgba(255, 193, 7, 0.2);
  padding: 35px 25px;
  box-shadow: 0 8px 28px rgba(11, 27, 63, 0.10);
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  transition: 0.35s ease;
  position: relative;
  overflow: hidden;
}

/* Hover */
.formation-card:hover {
  transform: translateY(-12px) scale(1.02);
  box-shadow: 0 18px 40px rgba(11, 27, 63, 0.22);
  border-color: rgba(255, 193, 7, 0.6);
}

/* Bande lumineuse animée */
.formation-card::before {
  content: "";
  position: absolute;
  top: -40%;
  left: -30%;
  width: 160%;
  height: 180%;
  background: radial-gradient(
    circle,
    rgba(255, 193, 7, 0.18) 0%,
    transparent 60%
  );
  transform: rotate(25deg);
  transition: opacity 0.5s ease;
  opacity: 0;
}

.formation-card:hover::before {
  opacity: 1;
}

/* -------- ICON -------- */
.formation-icon-wrapper {
  width: 82px;
  height: 82px;
  border-radius: 18px;
  background: rgba(11, 27, 63, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 22px;
  box-shadow: 0 0 12px rgba(255, 193, 7, 0.5);
  transition: 0.3s ease;
}

/* Hover */
.formation-card:hover .formation-icon-wrapper {
  box-shadow: 0 0 20px rgba(255, 193, 7, 0.8);
  transform: scale(1.05);
}

.formation-icon {
  font-size: 40px;
  color: #ffc107;
}

/* -------- TITRE -------- */
.formation-title {
  font-size: 1.3rem;
  font-weight: 700;
  color: #0b1b3f;
  margin-bottom: 15px;
}

/* -------- DESCRIPTION -------- */
.formation-niveau {
  margin-top: auto;
  background: rgba(255, 255, 255, 0.35);
  border-left: 4px solid #ffc107;
  padding: 14px 18px;
  border-radius: 14px;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.formation-niveau i {
  font-size: 20px;
  color: #0b1b3f;
  opacity: 0.8;
  margin-right: 10px;
}

.formation-niveau span {
  font-size: 0.97rem;
  color: #1d1d1d;
  line-height: 1.55;
  font-weight: 500;
}

/* -------- RESPONSIVE -------- */
@media (max-width: 768px) {
  .formation-card {
    padding: 28px;
  }
  .formation-icon-wrapper {
    width: 70px;
    height: 70px;
  }
  .formation-icon {
    font-size: 34px;
  }
  .formation-title {
    font-size: 1.15rem;
  }
}

.col-xl-3, .col-lg-4, .col-md-6 {
  flex: 1 1 33.33%;
  max-width: 33.33%;
}

</style>